import * as yup from 'yup'

const mlSearchFormValidationSchema = yup
  .object({
    question_placeholder: yup.string().optional(),
    acknowledgementMessages: yup.array().of(
      yup.object().shape({
        message: yup.string().required('This field is required')
      })
    ),
    feedbackMessages: yup.array().of(
      yup.object().shape({
        message: yup.string().required('This field is required')
      })
    ),
    emptyResponseMessage: yup
      .string()
      .max(250, 'Field should not contain more than ${max} characters')
      .when('$showEmptyResponseMessage', (showEmptyResponseMessage, schema) =>
        showEmptyResponseMessage ? schema.required('This field is required') : schema.optional()
      ),
    selectedSections: yup
      .object()
      .test(
        'selectedSections-test',
        'Please select one or more KnowledgeBase Sections to lookup articles',
        (selectedSections, form) => {
          const combinedValues = Object.values(selectedSections).flat()
          return (form.parent.enableKBFilter && combinedValues.length > 0) || !form.parent.enableKBFilter
        }
      ),
    selectedTags: yup
      .array()
      .test('selectedTags-test', 'Please select one or more Tags to lookup articles', (selectedTags, form) => {
        return (form.parent.enableTagsFilter && selectedTags?.length > 0) || !form.parent.enableTagsFilter
      }),
    helpfulLabel: yup.string().required('This field is required'),
    helpfulAction: yup
      .object()
      .shape({
        type: yup.string().required('This field is required'),
        step: yup.string().when('type', {
          is: 'endChat',
          then: yup.string().optional(),
          otherwise: yup.string().required('This field is required')
        }),
        followupMessage: yup
          .string()
          .when('type', { is: 'endChat', then: yup.string().required('This field is required') })
      })
      .optional(),
    notHelpfulLabel: yup.string().required('This field is required'),
    notHelpfulAction: yup
      .object()
      .shape({
        type: yup.string().required('This field is required'),
        step: yup.string().when('type', {
          is: 'endChat',
          then: yup.string().optional(),
          otherwise: yup.string().required('This field is required')
        }),
        followupMessage: yup
          .string()
          .when('type', { is: 'endChat', then: yup.string().required('This field is required') })
      })
      .optional(),
    noResultLabel: yup.string().required('This field is required'),
    noResultAction: yup
      .object()
      .shape({
        type: yup.string().required('This field is required'),
        step: yup.string().when('type', {
          is: 'endChat',
          then: yup.string().optional(),
          otherwise: yup.string().required('This field is required')
        }),
        followupMessage: yup
          .string()
          .when('type', { is: 'endChat', then: yup.string().required('This field is required') })
      })
      .optional()
  })
  .required()

export default mlSearchFormValidationSchema
